import URL_BACKEND from "../config/back-end";

const myHeaders = new Headers({
  "Content-type": "application/json",
});

function postAuth(object, api) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "POST",
      body: JSON.stringify(object),
      headers: myHeaders,
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.ok) {
          resolver(res);
          return res;
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => reject(err));
  });
}

function post(api, object) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "POST",
      body: JSON.stringify(object),
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ` + sessionStorage.getItem("app-token"),
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.ok) {
          resolver(res);
          return res;
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

async function get(api) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ` + sessionStorage.getItem("app-token"),
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.ok) {
          resolver(res);
          return res;
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function put(api, object) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "PUT",

      body: JSON.stringify(object),
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ` + sessionStorage.getItem("app-token"),
      },
    })
      .then(async (response) => {
        const res = await response.json();
        if (response.ok) {
          resolver(res);
          return res;
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => reject(err));
  });
}

async function getSemToken(api) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then(async (response) => {
        const res = await response.json();

        if (response.ok) {
          resolver(res);
          return res;
        } else {
          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => reject(err));
  });
}

function deletar(api) {
  return new Promise((resolver, reject) => {
    fetch(`${URL_BACKEND}${api}`, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ` + sessionStorage.getItem("app-token"),
      },
    })
      .then(async (response) => {
        if (response.ok) {
          resolver(true);
        } else if (response.status === 403) {
          sessionStorage.clear();
          window.location.reload();
        } else {
          const res = await response.json();

          reject(new Error(res.codigo + " : " + res.mensagem));
        }
      })
      .catch((err) => reject(err));
  });
}

export default { postAuth, get, put, post, getSemToken, deletar };
